/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespAboutModule_item = {
    readonly isCustomizable: boolean | null;
    readonly attributes: {
        readonly customizable: ReadonlyArray<{
            readonly option: {
                readonly serviceId: string | null;
            } | null;
            readonly text: string | null;
        } | null> | null;
        readonly ringResizable: ReadonlyArray<{
            readonly option: {
                readonly serviceId: string | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDescriptionAbout_item" | "PdpSharedDescriptionAdditionalOptions_item" | "PdpRespDetails_item">;
    readonly " $refType": "PdpRespAboutModule_item";
};
export type PdpRespAboutModule_item$data = PdpRespAboutModule_item;
export type PdpRespAboutModule_item$key = {
    readonly " $data"?: PdpRespAboutModule_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespAboutModule_item">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeOption",
  "kind": "LinkedField",
  "name": "option",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespAboutModule_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCustomizable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemAttributes",
      "kind": "LinkedField",
      "name": "attributes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AttributeValue",
          "kind": "LinkedField",
          "name": "customizable",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "text",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AttributeValue",
          "kind": "LinkedField",
          "name": "ringResizable",
          "plural": true,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDescriptionAbout_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDescriptionAdditionalOptions_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDetails_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();
(node as any).hash = '94836f5f223972a372ac99478b744c1e';
export default node;
